{
  "login-secret-with-password-page": {
    "buttons": {
      "forgot-password": "Zapomenuté heslo",
      "login": "Přihlášení",
      "set-password": "Nastavení hesla",
      "update-password": "Aktualizace hesla"
    },
    "text": {
      "new-password": "Nastavení hesla",
      "new-password-hint": "Vaše heslo bude vyžadováno pro budoucí přihlášení",
      "password": "Heslo",
      "password-invalid": "Vaše heslo je nesprávné. Zkuste to prosím znovu!",
      "password-hint": "Pro přihlášení zadejte své heslo",
      "update-password": "Nové heslo",
      "update-password-hint": "Zadejte prosím své nové heslo",
      "your-password": "Vaše heslo"
    }
  }
}
